/**
 * Browser URL for the admin SPA (React Router).
 * REST API paths stay under `/api/admin/...` — do not change those here.
 *
 * The old `/admin` path is disabled in App.js (redirects to `/`).
 */
export const ADMIN_PANEL_BASE_PATH = '/sw92team';

export function isAdminPanelPath(pathname) {
  if (!pathname || typeof pathname !== 'string') return false;
  return (
    pathname === ADMIN_PANEL_BASE_PATH ||
    pathname.startsWith(`${ADMIN_PANEL_BASE_PATH}/`)
  );
}
